// gatsby-browser.js
import './src/locales/i18n';
import React from 'react';
import { ThemeProvider } from 'styled-components';
import { darkTheme } from './src/components/theme';
import { GlobalStyle } from './src/components/common/GlobalStyle';
import Notifications from 'react-notify-toast';
import SWUpdateNotifier from './src/components/SWUpdateNotifier';

// Gatsby wrappt die App mit deinem Theme + Notifications
export const wrapRootElement = ({ element }) => (
  <ThemeProvider theme={darkTheme}>
    <GlobalStyle />
    {element}
    <Notifications />
    <SWUpdateNotifier />
  </ThemeProvider>
);

// 👉 Gatsby-Event: löst bei echtem SW-Update aus
export const onServiceWorkerUpdateReady = () => {
  // Custom DOM-Event feuern (global)
  window.dispatchEvent(new Event("swUpdateAvailable"));
};
